/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ opening: NonNullable<unknown>, closing: NonNullable<unknown> }} Partner_Billing_Contract_PrepaidInputs */



/**
* | output |
* | --- |
* | "Prepaid budget this period: {opening} available (including any change made during it), {closing} left at the end." |
*
* @param {Partner_Billing_Contract_PrepaidInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_billing_contract_prepaid = /** @type {((inputs: Partner_Billing_Contract_PrepaidInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Billing_Contract_PrepaidInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Vorausbezahltes Budget in diesem Zeitraum: ${i?.opening} verfügbar (einschließlich Änderungen während des Zeitraums), ${i?.closing} am Ende übrig.`)
	return /** @type {LocalizedString} */ (`Prepaid budget this period: ${i?.opening} available (including any change made during it), ${i?.closing} left at the end.`)
});